




































































































































import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { MsspModalObject, TenantModalObject, ProductModalObject } from '../types';
import UUIFComponents from '@/shared/uuifComponent';

const cssPrefix = 'provision-summary';
@Component({
  components: {
    ...UUIFComponents,
  },
})
export default class ProvisionSummary  extends SwExtendedVue {
  cssPrefix = cssPrefix;
  msspName: string = '';
  accessScope: string = '';
  tenantName: string = '';
  productName: string = '';
  newProductModalObject: ProductModalObject = {
    MSSPname: '',
    MsspId: '',
    tenantName: '',
    productDetails: [],
    tenantId: '',
    accessScopeMessage: '',
    authCode: '',
    serialNumber: '',
    friendlyName: '',
    performFurtherValidation: false,
    isdefaultgroupAssignedtoTenant: false,
  };
  newMsspModalObject:MsspModalObject = {
    MSSPname: '',
    emailAddress: '',
    contactName: '',
    companyName: '',
    phoneNumber: '',
    streetAddress: '',
    city: '',
    country: '',
    state: '',
    zipCode: '',
    isDefaultGroup: 'YES',
    MSSPID: '',
    additionalComments: '',
    province: '',
    firstName: '',
    lastName: '',
    msspNumber: '',
    msspContractid: '',
  };
  newTenantModalObject: TenantModalObject = {
    MSSPname: '',
    tenantName: '',
    contactName: '',
    companyName: '',
    emailAddress: '',
    phoneNumber: '',
    streetAddress: '',
    cityName: '',
    countryName: '',
    stateName: '',
    zipCode: '',
    additionalMessage: '',
    province: '',
    productGroupId: '',
    tenantNumber: '',
    tenantContractId: '',
  };

  onDone() {
    this.$emit('onCloseProductSummary');
  }

  get getMsspNewModaLObject() {
    return this.$store.getters['TenantManagementStoreModule/getNewMsspModalObject'];
  }

  get getTenantNewModalObject() {
    return this.$store.getters['TenantManagementStoreModule/getNewTenantModalObject'];
  }

  get productDetails() {
    return this.$store.getters['TenantManagementStoreModule/getNewProductModalObject'];
  }
  accessManagement() {
    this.$router.push({ path: '/mssp-access-management' });
  }
  hesNavigate() {
    this.$store.commit('MswProductsStoreModule/setSelectedSerialNumber', this.newProductModalObject.serialNumber);
    this.$router.push({ path: '/m/feature/hosted-email-security' });
  }
  created() {
    this.newMsspModalObject = this.getMsspNewModaLObject;
    this.newTenantModalObject = this.getTenantNewModalObject;
    this.newProductModalObject = this.productDetails;

    if (!(this.newTenantModalObject.MSSPname === '' && this.newTenantModalObject.tenantName === '')) {
      this.newProductModalObject.MSSPname = this.productDetails.MSSPname !== '' ? this.productDetails.MSSPname : this.newMsspModalObject.MSSPname;
      this.newProductModalObject.tenantName = this.productDetails.tenantName ? this.productDetails.tenantName : this.newTenantModalObject.tenantName;
    }
    this.newProductModalObject.serialNumber = this.productDetails.serialNumber ? this.productDetails.serialNumber : '';
    this.newProductModalObject.friendlyName = this.productDetails.friendlyName ? this.productDetails.friendlyName : '';
  }

  makeElipsis(item: string, size:number = 20) {
    if (item.length > size) {
      return `${item.slice(0, size)}...`;
    } return item;
  }
}
